import { render, staticRenderFns } from "./RchFiscalReceipt.vue?vue&type=template&id=9356776c&scoped=true&"
import script from "./RchFiscalReceipt.vue?vue&type=script&lang=js&"
export * from "./RchFiscalReceipt.vue?vue&type=script&lang=js&"
import style0 from "./RchFiscalReceipt.vue?vue&type=style&index=0&id=9356776c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9356776c",
  null
  
)

export default component.exports